import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a straight wall segment with the kit's standard window: the
// sill sits at 0.9 m and the head at 2.1 m, a glass pane in a thin matte
// frame. The glass is slightly thicker than the frame so it reads as a pane
// set in a border on both faces.
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";
const BLACK = "#2e2e30";
const GLASS = "#9fc4d4";

export const wallWindow = defineModel({
  id: "wall-window",
  batchId: "modern",
  name: "Wall with window",
  tags: ["modern", "interior", "outdoor", "structure", "wall", "window"],
  summary: "A wall segment with a framed window, sill at 0.9 m, head at 2.1 m.",
  description:
    "A one-tile plastered wall of the Modern Living kit with the standard " +
    "window opening: sill at 0.9 m, head at 2.1 m, a glass pane in a thin " +
    "matte-black frame. Same 0.12 m thickness and 2.6 m height as wall-plain.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // wall below the sill (0 -> 0.9)
      { geometry: new THREE.BoxGeometry(1.0, 0.9, 0.12), color: PLASTER, position: [0, 0.45, 0] },
      // wall above the head (2.1 -> 2.6)
      { geometry: new THREE.BoxGeometry(1.0, 0.5, 0.12), color: PLASTER, position: [0, 2.35, 0] },
      // jambs at both sides of the opening
      { geometry: new THREE.BoxGeometry(0.11, 1.2, 0.12), color: PLASTER, position: [-0.445, 1.5, 0] },
      { geometry: new THREE.BoxGeometry(0.11, 1.2, 0.12), color: PLASTER, position: [0.445, 1.5, 0] },
      // thin matte frame filling the opening
      { geometry: new THREE.BoxGeometry(0.78, 1.2, 0.06), color: BLACK, position: [0, 1.5, 0] },
      // glass pane, slightly thicker than the frame so it shows on both faces
      { geometry: new THREE.BoxGeometry(0.68, 1.1, 0.09), color: GLASS, position: [0, 1.5, 0] },
      // baseboard
      { geometry: new THREE.BoxGeometry(1.0, 0.1, 0.15), color: BASEBOARD, position: [0, 0.05, 0] },
    ];
  },
  animations: [],
});
